import {
  ByIdPayload,
  FailByIdPayload,
  OperationReducerTypes,
  PayloadAction,
  uniqueActionType
} from '@industi/ngx-common';

export const DictionaryCarbonMaterialDeleteActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[dictionary/carbon-material] Delete'),
  requestFail: uniqueActionType('[dictionary/carbon-material] Delete fail'),
  requestSuccess: uniqueActionType('[dictionary/carbon-material] Delete success'),
  requestClearErrors: uniqueActionType('[dictionary/carbon-material] Delete clear errors'),
  requestClear: uniqueActionType('[dictionary/carbon-material] Delete clear')
};

export class DictionaryCarbonMaterialDeleteAction implements PayloadAction {
  readonly type = DictionaryCarbonMaterialDeleteActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryCarbonMaterialDeleteFailAction implements PayloadAction {
  readonly type = DictionaryCarbonMaterialDeleteActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DictionaryCarbonMaterialDeleteSuccessAction implements PayloadAction {
  readonly type = DictionaryCarbonMaterialDeleteActionTypes.requestSuccess;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryCarbonMaterialDeleteClearErrorsAction implements PayloadAction {
  readonly type = DictionaryCarbonMaterialDeleteActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryCarbonMaterialDeleteClearAction implements PayloadAction {
  readonly type = DictionaryCarbonMaterialDeleteActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
